import { transient } from "aurelia-framework";
import { BaseRuleConfigPlugin } from "../../../../rules/dialogs/add-rule/plugins/base-rule-config-plugin";

@transient()
export class ThirdPartyPlugin extends BaseRuleConfigPlugin {
   
    attached(){
        this.meta.isManual = true;
    }
    
    getSelectedItem($event){
        this.meta.name=$event.detail.item?.name;
    }
}